pageLoad('animes_coub', () => {
  $.force_appear();
});
